__turbopack_context__.v({
  "image": "PatchworkGallery-module__pXcRIG__image",
  "imageWrapper": "PatchworkGallery-module__pXcRIG__imageWrapper",
  "videoWrapper": "PatchworkGallery-module__pXcRIG__videoWrapper",
});
